// src/Services/AuthenticationService/RegisterApi.ts
import axios from "axios";
import { AppDispatch } from "../../store"; // adjust if you have store types
import { getClientConfig } from "../../config/clientConfig";
import { error } from "console";
import AlertMessage from "../../Components/AlertMessage/AlertMessage";
import ApiConfig from "../../Utils/Configs/apiConfig";
// Type for Register Form Data
export interface RegisterFormValues {
  role: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  telephoneNumber: string;
  companyName: string;
}
console.log(getClientConfig, "getClientConfig");
// Response type (you can update based on your backend)
interface RegisterResponse {
  message: string;
  token?: string;
}
const clientConfig = getClientConfig();
console.log("getClientConfig", clientConfig);

export const RegisterApi = async (
  dispatch: AppDispatch,
  formDatas: RegisterFormValues,
  data: RegisterFormValues
): Promise<RegisterResponse> => {
  try {
    const response = await axios.post<RegisterResponse>(
      `${clientConfig.backend_url}/Account/register`,
      data
    );

    // if you want to store user or token in redux, dispatch here
    dispatch({ type: "REGISTER_SUCCESS", payload: response.data });

    return response.data;
  } catch (error: any) {
    // dispatch({ type: "REGISTER_FAILURE", payload: error.response?.data });
    throw error.response?.data || { message: "Registration failed" };
  }
};

export const RegisterUser = async (data: RegisterFormValues) => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Account/register",
      data
    );
    if (response.status === 200) {
      return { status: true, message: "Registration Successful" };
    }
    return { status: false, message: "Registration Unsuccessful" };
  } catch (error: any) {
    return { status: false, message: error.response.data.message };
    console.log();
  }
};
